(function () {
  "use strict";

  var e = {
    175: function _(e, t, r) {
      var s,
          i = this && this.__createBinding || (Object.create ? function (e, t, r, s) {
        void 0 === s && (s = r);
        var i = Object.getOwnPropertyDescriptor(t, r);
        i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
          enumerable: !0,
          get: function get() {
            return t[r];
          }
        }), Object.defineProperty(e, s, i);
      } : function (e, t, r, s) {
        void 0 === s && (s = r), e[s] = t[r];
      }),
          n = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
          a = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var r in e) {
          "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
        }
        return n(t, e), t;
      },
          o = this && this.__spreadArray || function (e, t, r) {
        if (r || 2 === arguments.length) for (var s, i = 0, n = t.length; i < n; i++) {
          !s && i in t || (s || (s = Array.prototype.slice.call(t, 0, i)), s[i] = t[i]);
        }
        return e.concat(s || Array.prototype.slice.call(t));
      },
          u = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.validateAddress = t.getPubKeyHash = t.AddressTypes = t.normalizeTransactionObject = t.decodeRawTransaction = t.selectCoins = t.getAddressNetwork = t.compressPubKey = t.calculateFee = void 0;
      var c = r(238),
          d = r(869),
          p = r(64),
          l = r(574),
          f = r(674),
          h = r(517),
          v = u(r(215)),
          y = a(r(555)),
          g = a(r(560)),
          b = u(r(685)),
          x = u(r(701));
      t.AddressTypes = ["legacy", "p2sh-segwit", "bech32"], t.calculateFee = function (e, t, r) {
        return (280 * e + 33 * t + 18) * r;
      }, t.compressPubKey = function (e) {
        var t = e.substring(2, 66),
            r = e.substring(66, 130);
        return (parseInt(r.substring(62, 64), 16) % 2 == 0 ? "02" : "03") + t;
      }, t.getAddressNetwork = function (e) {
        var t,
            r = c.base58.decode(e).toString("hex").substring(0, 2);
        return t = (0, h.findKey)(d.YacoinNetworks, function (e) {
          return [(0, c.padHexStart)(e.pubKeyHash.toString(16), 1), (0, c.padHexStart)(e.scriptHash.toString(16), 1)].includes(r);
        }), d.YacoinNetworks[t];
      }, t.selectCoins = function (e, t, r, s) {
        void 0 === s && (s = []);
        var i = e,
            n = s.length ? x.default : b.default;
        s.length && (i = o(o([], s, !0), e.filter(function (e) {
          return !s.find(function (t) {
            return t.vout === e.vout && t.txid === e.txid;
          });
        }), !0));
        var a,
            u = n(i, t, Math.ceil(r)),
            c = u.inputs,
            d = u.outputs,
            p = u.fee;
        return c && d && (a = d.find(function (e) {
          return "main" !== e.id;
        })), {
          inputs: c,
          outputs: d,
          fee: p,
          change: a
        };
      };
      var w = ((s = {})[g.types.P2WPKH] = "witness_v0_keyhash", s[g.types.P2WSH] = "witness_v0_scripthash", s);

      function m(e, t) {
        var r = y.address.toOutputScript(e, t),
            s = g.output(r);
        if (s !== g.types.P2PKH) throw new Error("Yacoin swap doesn't support the address ".concat(e, " type of ").concat(s, ". Not possible to derive public key hash."));
        return y.address.fromBase58Check(e).hash;
      }

      t.decodeRawTransaction = function (e, t) {
        var r = y.Transaction.fromHex(e),
            s = r.ins.map(function (e) {
          return {
            txid: Buffer.from(e.hash).reverse().toString("hex"),
            vout: e.index,
            scriptSig: {
              asm: y.script.toASM(e.script),
              hex: e.script.toString("hex")
            },
            sequence: e.sequence
          };
        }),
            i = r.outs.map(function (e, r) {
          var s = g.output(e.script),
              i = {
            value: e.value / 1e6,
            n: r,
            scriptPubKey: {
              asm: y.script.toASM(e.script),
              hex: e.script.toString("hex"),
              reqSigs: 1,
              type: w[s] || s,
              addresses: []
            }
          };

          try {
            var n = y.address.fromOutputScript(e.script, t);
            i.scriptPubKey.addresses.push(n);
          } catch (e) {}

          return i;
        });
        return {
          txid: r.getHash().reverse().toString("hex"),
          hash: r.getHash().reverse().toString("hex"),
          version: r.version,
          time: r.time,
          locktime: r.locktime,
          size: r.byteLength(),
          vsize: r.virtualSize(),
          weight: r.weight(),
          vin: s,
          vout: i,
          hex: e
        };
      }, t.normalizeTransactionObject = function (e, t, r) {
        var s = e.vout.reduce(function (e, t) {
          return e.plus(new v.default(t.value).times(1e6));
        }, new v.default(0)),
            i = {
          hash: e.txid,
          value: s.toNumber(),
          _raw: e,
          confirmations: 0,
          status: e.confirmations > 0 ? p.TxStatus.Success : p.TxStatus.Pending
        };

        if (t) {
          var n = Math.round(t / e.vsize);
          Object.assign(i, {
            fee: t,
            feePrice: n
          });
        }

        return r && Object.assign(i, {
          blockHash: r.hash,
          blockNumber: r.number,
          confirmations: e.confirmations
        }), i;
      }, t.getPubKeyHash = m, t.validateAddress = function (e, t) {
        var r,
            s = (0, l.addressToString)(e);
        if ("string" != typeof s) throw new f.InvalidAddressError("Invalid address: ".concat(s));

        try {
          r = m(s, t);
        } catch (e) {
          throw new f.InvalidAddressError("Invalid Address. Failed to parse: ".concat(s));
        }

        if (!r) throw new f.InvalidAddressError("Invalid Address: ".concat(s));
      };
    },
    238: function _(e) {
      e.exports = require("@yaswap/crypto");
    },
    674: function _(e) {
      e.exports = require("@yaswap/errors");
    },
    64: function _(e) {
      e.exports = require("@yaswap/types");
    },
    574: function _(e) {
      e.exports = require("@yaswap/utils");
    },
    869: function _(e) {
      e.exports = require("@yaswap/yacoin-networks");
    },
    555: function _(e) {
      e.exports = require("@yaswap/yacoinjs-lib");
    },
    560: function _(e) {
      e.exports = require("@yaswap/yacoinjs-lib/src/classify");
    },
    215: function _(e) {
      e.exports = require("bignumber.js");
    },
    685: function _(e) {
      e.exports = require("coinselect");
    },
    701: function _(e) {
      e.exports = require("coinselect/accumulative");
    },
    517: function _(e) {
      e.exports = require("lodash");
    }
  },
      t = {},
      r = function r(s) {
    var i = t[s];
    if (void 0 !== i) return i.exports;
    var n = t[s] = {
      exports: {}
    };
    return e[s].call(n.exports, n, n.exports, r), n.exports;
  }(175);

  module.exports = r;
})();